module.exports = __webpack_public_path__ + "static/media/visibility-icon.96bb025a.svg";